// import { merchantStroe } from "@/stores";
import { useAuthContext } from "@/auth/useAuthContext";
import CreateSwapOrder from "./CreateSwapOrder";
import GetSwapPrice from "./GetSwapPrice";
import GetSwapRecord from "./GetSwapRecord";
import GetSwapRecoredList from "./GetSwapRecoredList";
import {
  SWAP_CREATE,
  SWAP_ESTIMATE,
  SWAP_RECORD,
  SWAP_RECORD_LIST,
} from "@/config";

export default function Index() {
  // const { UserInfo } = merchantStroe;
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  let SWAP_ESTIMATE_ = check ? SWAP_ESTIMATE : "***";
  let SWAP_CREATE_ = check ? SWAP_CREATE : "***";
  let SWAP_RECORD_ = check ? SWAP_RECORD : "***";
  let SWAP_RECORD_LIST_ = check ? SWAP_RECORD_LIST : "***";
  return (
    <>
      <GetSwapPrice url={SWAP_ESTIMATE_} />
      <CreateSwapOrder url={SWAP_CREATE_} />
      <GetSwapRecord url={SWAP_RECORD_} />
      <GetSwapRecoredList url={SWAP_RECORD_LIST_} />
    </>
  );
}
